import request from '@/utils/request.js'


/**
 * APP-工作室-接单-需要对应的证书
 * @param params
 * @returns {AxiosPromise}
 */
export function getSkill(params) {
    return request({
        closeInterceptors: true,
        url: 'tradeService/api/app/workstation/order/getSkill',
        method: 'post',
        data: params
    })
}

/**
 * APP-工作室-接单
 * @param params
 * @returns {AxiosPromise}
 */
export function receiveOrder(params) {
    return request({
        closeInterceptors: true,
        url: 'tradeService/api/app/workstation/order/receiveOrder',
        method: 'post',
        data: params
    })
}




/**
 * APP-工作室-发单
 * @param params
 * @returns {AxiosPromise}
 */
export function saveOrder(params) {
    return request({
        url: 'tradeService/api/app/workstation/order/saveOrder',
        method: 'post',
        data: params
    })
}

/**
 * 发现-首页-推荐服务产品订单详情(未接)
 * @param params
 * @returns {AxiosPromise}
 */
export function getServiceProductOrderRecommendDetail(params) {
    return request({
        url: 'tradeService/api/app/orderServiceProduct/getServiceProductOrderRecommendDetail',
        method: 'post',
        data: params
    })
}

/**
 * 发现-首页-服务产品订单(未接)
 * @param params
 * @returns {AxiosPromise}
 */
export function getServiceProductOrderUnreceivedDetail(params) {
    return request({
        url: 'tradeService/api/app/orderServiceProduct/getServiceProductOrderUnreceivedDetail',
        method: 'post',
        data: params
    })
}

/**
 * 发现-首页-服务产品订单(已接)
 * @param params
 * @returns {AxiosPromise}
 */
export function getServiceProductOrderReceivedDetail(params) {
    return request({
        url: 'tradeService/api/app/orderServiceProduct/getServiceProductOrderReceivedDetail',
        method: 'post',
        data: params
    })
}


/**
 * 更新服务产品子订单记录(出发/开始服务/服务完成)
 * @param params
 * @returns {AxiosPromise}
 */
export function updateOrderServiceProductStatus(params) {
    return request({
        url: 'tradeService/api/app/orderServiceProduct/updateOrderServiceProductStatus',
        method: 'post',
        data: params
    })
}

/**
 * 服务订单子项预约服务时间
 * @param params
 * @returns {AxiosPromise}
 */
export function appointmentFirstServiceTime(params) {
    return request({
        url: 'tradeService/api/app/orderServiceProduct/appointmentFirstServiceTime',
        method: 'post',
        data: params
    })
}

export function preBuyCheckCourseOrder(params) {
    return request({
        url: 'tradeService/api/app/orderCommodity/preBuyCheckCourseOrder',
        method: 'post',
        data: params
    })
}
